import type { TabsContent } from './PopupPayment.types';
export const tabsContent: TabsContent = {
  deposit: ['payment.deposit', 'Deposit'],
  withdrawal: ['payment.withdrawal', 'Withdrawal'],
  history: ['payment.history', 'History']
};